"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TotalAssets = void 0;
const icons_1 = require("@components/icons");
const react_1 = __importDefault(require("react"));
require("./styles.scss");
const TotalAssets = (props) => {
    const { totalAssets } = props;
    return (react_1.default.createElement("div", { className: "c-total-assets" },
        react_1.default.createElement("div", { className: "c-total-assets-item" },
            react_1.default.createElement(icons_1.EthereumIcon, null),
            react_1.default.createElement("div", { className: "c-total-assets-item-info" },
                react_1.default.createElement("h3", null, "Assets on Ethereum"),
                react_1.default.createElement("p", null,
                    "$", totalAssets === null || totalAssets === void 0 ? void 0 :
                    totalAssets.ethereum))),
        react_1.default.createElement("div", { className: "c-total-assets-item" },
            react_1.default.createElement(icons_1.PolygonIcon, null),
            react_1.default.createElement("div", { className: "c-total-assets-item-info" },
                react_1.default.createElement("h3", null, "Assets on Polygon"),
                react_1.default.createElement("p", null,
                    "$", totalAssets === null || totalAssets === void 0 ? void 0 :
                    totalAssets.polygon))),
        react_1.default.createElement("div", { className: "c-total-assets-item" },
            react_1.default.createElement(icons_1.BNBIcon, null),
            react_1.default.createElement("div", { className: "c-total-assets-item-info" },
                react_1.default.createElement("h3", null, "Assets on BNB"),
                react_1.default.createElement("p", null,
                    "$", totalAssets === null || totalAssets === void 0 ? void 0 :
                    totalAssets.bnb))),
        react_1.default.createElement("div", { className: "c-total-assets-item" },
            react_1.default.createElement(icons_1.ArbiIcon, null),
            react_1.default.createElement("div", { className: "c-total-assets-item-info" },
                react_1.default.createElement("h3", null, "Assets on Arbitrum"),
                react_1.default.createElement("p", null,
                    "$", totalAssets === null || totalAssets === void 0 ? void 0 :
                    totalAssets.arbi)))));
};
exports.TotalAssets = TotalAssets;
